import React, {useState} from 'react';
import Equalizer from 'react-equalizer';
import {NavLink as Link} from 'react-router-dom';
import ImageResponsive from '../../../contentful/ImageResponsive';

const ModelPagesList = (props) => {
  const [hideArchived, setHideArchived] = useState(true);

  return <div>
    <div className="pull-right">
      <button onClick={props.onCreate}
        className={`${props.modelModified ? 'disabled ' : ''}btn btn-default`}
      >
        <i className="fa fa-plus" aria-hidden="true"></i> Legg til underside
      </button>
      &nbsp;
      <button onClick={(e) => {
        e.preventDefault();
        setHideArchived(!hideArchived);
      }} className="btn btn-info">
        {hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
      </button>
    </div>
    <div className="row clearboth">
      {props.pages && <Equalizer byRow={false}>
        {props.pages.map((page) => {
          if (hideArchived && page.archived) {
            return;
          }

          let statusClass = 'warning';
          let text = 'Kladd';

          if (page.published) {
            if (page.updated) {
              statusClass = 'info';
              text = 'Oppdatert';
            } else {
              statusClass = 'success';
              text = 'Publisert';
            }
          } else if (page.archived) {
            statusClass = 'danger';
            text = 'Arkivert';
          }

          const toLink = `side/${page.id}`;
          const isVideo = page.image?.contentType.startsWith('video/');

          return (
            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3" title={text} key={page.id}>
              <div className={`panel panel-${statusClass}`}>
                <div className="panel-heading">
                  <h3 className="panel-title">{page.title || '*Ny underside*'}</h3>
                </div>
                <div className="panel-body">
                  <div className="row">
                    <div className="col-xs-12 mf-margin-bottom-10 text-center">
                      {page.image && !isVideo &&
                        <ImageResponsive
                          src={page.image.url}
                          width={300}
                          height={200}
                          aspect={1.5}
                        />
                      }
                      {page.image && isVideo &&
                        <i className="fa fa-5x fa-file-video-o" aria-hidden="true"></i>
                      }
                    </div>
                  </div>
                </div>
                <div className="panel-footer">
                  <Link
                    to={toLink}
                    disabled={(props.disabled)}
                    className={`${props.disabled ? 'disabled ' : ''}btn btn-default`}
                  >
                    <i className="fa fa-pencil" aria-hidden="true"></i> Endre
                  </Link>
                  {/*TODO: Add publish/unpublish buttons here*/}
                </div>
              </div>
            </div>
          );
        })}
      </Equalizer>}
    </div>
  </div>;
};

export default ModelPagesList;

